import { render, staticRenderFns } from "./QMatrizComposicion.vue?vue&type=template&id=15895e9a&scoped=true"
import script from "./QMatrizComposicion.vue?vue&type=script&lang=js"
export * from "./QMatrizComposicion.vue?vue&type=script&lang=js"
import style0 from "./QMatrizComposicion.vue?vue&type=style&index=0&id=15895e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15895e9a",
  null
  
)

export default component.exports